import { NodeSelection } from 'prosemirror-state';

import { EditorView } from '@lyearn/lygo-core';

import { blockMenuKey } from '../../plugins/BlockMenu/utils/utils';
import { getElementPos } from '../../utils';
import { displayReplaceMenuItem } from '../BlockMenu/utils/actions';
import { HIDE_BLOCK_MENU_CLASSNAME } from './consts';
import { BlockMenuButtonProps } from './types';

// ref: https://github.com/ProseMirror/prosemirror-view/blob/dfa84353afc7603a250501cbaaf2a684f6d6c2be/src/input.js#L550
export class Dragging {
  slice: any;
  move: any;

  constructor(slice: any, move: any) {
    this.slice = slice;
    this.move = move;
  }
}

const isMac = (globalThis.navigator?.platform ?? '').toUpperCase().indexOf('MAC') >= 0;
export const dragCopyModifier = isMac ? 'altKey' : 'ctrlKey';

export const getBlockElmentOnHover = (targetElement: any) => {
  let blockElement = targetElement;
  if (blockElement.classList.contains('ProseMirror')) {
    return null;
  }

  while (
    blockElement.parentNode &&
    (!blockElement.parentNode.classList ||
      !blockElement.parentNode.classList.contains('ProseMirror'))
  ) {
    blockElement = blockElement.parentNode;

    /* add this class to hide the block-menu-button temporarily */
    if (blockElement.classList?.contains(HIDE_BLOCK_MENU_CLASSNAME)) {
      return null;
    }
  }
  return blockElement;
};

export const isBlockmenuOpen = (view: EditorView) => {
  return blockMenuKey.getState(view.state)?.open;
};

export const getBlockMenuButtonDefaultProps = (isLocalizedContent: boolean) => ({
  open: true,
  anchorEl: null,
  isLocalizedContent,
});

export const showBlockMenuButton = ({
  view,
  isLocalizedContent,
  anchorEl,
  open,
}: BlockMenuButtonProps) => {
  let showMenueButton = true;

  if (view && anchorEl && isLocalizedContent) {
    const elementPos = getElementPos(anchorEl, view);
    if (elementPos && elementPos.inside !== undefined) {
      const selectedNode = new NodeSelection(view.state.doc.resolve(elementPos.inside));
      if (selectedNode) {
        const isReplace = displayReplaceMenuItem(open, anchorEl, view, selectedNode.node);
        if (!isReplace) showMenueButton = false;
      }
    }
  }
  return showMenueButton;
};
